import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormErrorMessage } from "../../../components";
import { ThreeWayCallReDialRequest } from "../../../models/api/Call";
import { DialPad } from '../../../components';
import { AssetSvg } from '../../../assets';
import { Dispatch, SetStateAction, CSSProperties } from 'react';
import { logger } from '../../../utils';
import { useDispatch } from 'react-redux';
import { CallStatusType } from "../../../configs";
import { ActionAudioCall, useAppDispatch, useAppSelector, VRIAppStateType } from "../../../core";
import { AudioConferenceCalls } from "../../../models";
import { isValidUSPhoneNumber } from "../../../utils/phoneNumberFormatting";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  callinfo: any;
  onCallConferenceParticipant: (value: ThreeWayCallReDialRequest) => Promise<any>;
  handleDisconnect: Function;
  audioConferenceCalls: AudioConferenceCalls;
};

export function ModalOutboundCallDial({
  show,
  handleShow,
  callinfo,
  onCallConferenceParticipant,
  handleDisconnect,
  audioConferenceCalls
  }: Props) {

  const [dialedInput, setDialedInput] = useState('');
  const { register, handleSubmit, formState: { errors }, setValue, setError, clearErrors } = useForm<any>();

  const dispatch = useDispatch();

  const data = useAppSelector((state: VRIAppStateType) => ({
    audioConferenceCalls: state.audioCall.audioConferenceCalls
  }));

  // useEffect(() => {
  //   console.log("audioConferenceCalls updated:", data.audioConferenceCalls);
  // }, [data.audioConferenceCalls]);




  const dialedInputStyle = {
    minWidth:
      dialedInput.length > 25 ? dialedInput.length * 10 + 'px' : '250px',
  };

  function isNumberAlreadyIncall(input: string): boolean {
    // console.log("audioConferenceCalls:", audioConferenceCalls);

    let fullnumber = input;
    if (input.length === 10) {
      fullnumber = '1' + input;
    }

    const activeStatuses = [18, 21, 22, 24];
    return audioConferenceCalls.some((call) => {
      return call.calledNumber === fullnumber &&
        call.status?.current !== undefined &&
        activeStatuses.includes(call.status.current);
    });
  }


  useEffect(() => {
    clearErrors();
  }, [dialedInput])

  const onSubmitData = (value: ThreeWayCallReDialRequest) => {

    if (!isValidUSPhoneNumber(dialedInput)) {
      setError("phoneNumber", {
        type: "manual",
        message: "Invalid US phone number",
      });
      return;
    }
    else if (isNumberAlreadyIncall(dialedInput)) {
      setError("phoneNumber", {
        type: "manual",
        message: "Participant is already in call",
      });
      return;
    }
      else {
        clearErrors("phoneNumber");
        handleShow(false);

        value.phoneNumber = dialedInput;
        value.callSid = callinfo.customParameters?.get("CallSid");
        dispatch(
          ActionAudioCall.RemoveAudioConferenceCallByCalledNumber(
            normalizeUSPhoneNumber(dialedInput)
          )
        );
        setDialedInput("");
        onCallConferenceParticipant(value).then((a) => {
          // handleShow(false);
        });
    }
  };

  function normalizeUSPhoneNumber(phone: string): string {
    const digitsOnly = phone.replace(/\D/g, '');

    if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
      return digitsOnly;
    }

    if (digitsOnly.length === 10) {
      return '1' + digitsOnly;
    }

    throw new Error('Invalid US phone number format');
  }

  return (
    <Modal show={show} onHide={() => { setDialedInput(''); handleShow(false); clearErrors() }} centered>
      <form onSubmit={handleSubmit(onSubmitData)}>
        <Modal.Header closeButton>
          <Modal.Title>Call Participant</Modal.Title>
        </Modal.Header>

        <Modal.Body className="dialer-modal-body">
          <div className="dialer-modal">
            <div className="d-flex flex-column justify-content-center align-items-center dialer-content">
              {errors["phoneNumber"] && (
                <FormErrorMessage message={errors["phoneNumber"]?.message as string || "This field is required"} />
              )}
              <DialPad
                dialedInput={dialedInput}
                dialedInputStyle={dialedInputStyle}
                setDialedInput={setDialedInput}
                handleDisconnect={handleDisconnect}
              />
              <div className="d-flex flex-row">
                <div className="key-row dial-button mt-2">
                  <button
                    type="submit"
                    className="btn mx-4 callPage-controlBtn btn-green"
                    onClick={() => {
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

      </form>
    </Modal>
  );
}
